export const github = "https://github.com/Forhadx";
export const linkedIn = "https://www.linkedin.com/in/shamsul-haque-forhad/";

export const projectsList = [
  {
    id: 1,
    name: "Calculator",
    type: "",
    image: "1.png",
    github: "https://github.com/Forhadx/calculator-redux",
    live: "https://calculator-fx.netlify.app/",
    tags: ["reactjs", "redux", "css", "html", "netlify"],
    description:
      "This is a basic calculator where users can addition, subtraction, multiplication, and division operation",
  },
  {
    id: 2,
    name: "Youtube",
    type: "clone",
    image: "2.png",
    github: "https://github.com/Forhadx/mini-youtube-react",
    live: "https://youtube-clone-fx.netlify.app/",
    tags: ["reactjs", "rest-api", "css", "html", "netlify"],
    description:
      "This is a clone of youtube. User can search any video and this site show the video and also show some similar video related of searching.",
  },
  {
    id: 3,
    name: "State Info",
    type: "",
    image: "3.png",
    github: "https://github.com/Forhadx/state-info-by-react",
    live: "https://state-info.netlify.app/",
    tags: ["reactjs", "firebase", "css", "html", "netlify"],
    description:
      "On this site, visitors can see different state's short information. Each state's information attached with a description, pictures, map. Admin Add the information of all states.",
  },
  {
    id: 11,
    name: "Unsplash ",
    type: "clone",
    image: "11.png",
    github: "https://github.com/Forhadx/unplash-clone-react",
    live: "https://unplash-clone-fx.netlify.app/",
    tags: ["reactjs", "redux", "rest-api", "css", "html", "netlify"],
    description:
      "All image information fetch from Unsplash API. Redux is using to manage the API data.",
  },
  {
    id: 12,
    name: "Diary App",
    type: "",
    image: "12.png",
    github: "https://github.com/Forhadx/diary-react",
    live: "https://diary-app-fx.netlify.app/",
    tags: ["reactjs", "redux", "firebasae", "css", "html", "netlify"],
    description:
      "In the Diary App user first, log in by email. Then they can write there. All of the writings see on the home page. User can make a favourite list of posts. Posts can be deleted and updated by the user. At last user can logout by there account.",
  },
  {
    id: 13,
    name: "Resturent Landing Page",
    type: "",
    image: "13.png",
    github: "https://github.com/Forhadx/resturent-landing-page-react",
    live: "https://resturent-landing-page.netlify.app/",
    tags: ["reactjs", "emailjs", "scss", "html", "netlify"],
    description:
      "Restaurant food menu, about, location, customer review are displayed on this site. Visitors could send messages to the owner email by this site.",
  },
  {
    id: 14,
    name: "Rick and Morty",
    type: "",
    image: "14.png",
    github: "https://github.com/Forhadx/rick-morty-react",
    live: "https://rick-and-morty-fx.netlify.app/",
    tags: ["reactjs", "redux", "graphql-api", "scss", "html", "netlify"],
    description:
      "Rick and Morty is a Cartoon. In online have a graphql-api where have some data's of this cartoon. Using this data, I have made a website.",
  },
  {
    id: 15,
    name: "Kanban Board",
    type: "",
    image: "15.png",
    github: "https://github.com/Forhadx/dnd-kanbanboard-react",
    live: "https://kanban-board-forhadx.netlify.app/",
    tags: ["typescript", "reactjs", "dnd", "scss", "html", "netlify"],
    description:
      "Kanban board made with React js and Typescript. Pure vanilla is used in Drag and Drop. No Third-party library was used for Dnd. All data save on localStorage.",
  },
  {
    id: 21,
    name: "Gro-Mart",
    type: "admin",
    image: "21.png",
    github: "https://github.com/Forhadx/Ecommerce-MERN",
    live: "https://gomart-admin.netlify.app/",
    tags: [
      "nodejs",
      "expressjs",
      "reactjs",
      "redux",
      "mongodb",
      "mongoose",
      "scss",
      "html",
      "heroku",
      "netlify",
    ],
    description:
      "This is the admin panel of a grocery e-commerce site. Admin can visit all products and do crud operation. User can manage all order process. And also watch the list of users and their total buy amount.",
  },
  {
    id: 22,
    name: "Gro-Mart",
    type: "user",
    image: "22.png",
    github: "https://github.com/Forhadx/Ecommerce-MERN",
    live: "https://gomart-eccomerce.netlify.app/",
    tags: [
      "nodejs",
      "expressjs",
      "reactjs",
      "redux",
      "mongodb",
      "mongoose",
      "scss",
      "html",
      "heroku",
      "netlify",
    ],
    description:
      "This is the user panel of a grocery e-commerce site. Users can visit all products and make carts. during checkout users must signup/sign in to this site. After an order place, user can visit their order list and history.",
  },
  {
    id: 23,
    name: "Classroom",
    type: "",
    image: "23.png",
    github: "https://github.com/Forhadx/classroom-server",
    live: "https://classroom-frontend-forhadx.vercel.app/",
    tags: [
      "nodejs",
      "expressjs",
      "reactjs",
      "nextjs",
      "context-api",
      "mysql",
      "sequeize",
      "scss",
      "html",
      "heroku",
      "vercel",
    ],
    description:
      "This app like google classroom with addition has an attendance system. Faculty can create rooms. Take student attendance and share pdf files for students. Student can see their attendance history and download pdf files.",
  },
];

/*

    low: 1 - 10
    mid: 11 -20
    high: 21 - 30


    {
        id: 0,
        name: " ",
        type: "",
        image: "",
        github: "",
        live: "",
        tags: [],
        description: "",
    },


*/

export const guruList = [
  { id: 1, name: "Maximilian Schwarzmüller" },
  { id: 2, name: "Manuel Lorenz" },
  { id: 3, name: "Jonas Schmedtmann" },
  { id: 4, name: "Abdul Bari" },
  { id: 5, name: "Stephen Grider" },
  { id: 6, name: "Andrei Neagoie" },
];
